import request from '../../utils/request';

export const applyService = {
    //列表数据查询
    getQuotationApplyData: (data) => {
        return request({
            url: '/apply/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getQuotationApplyInfo: (applyId) => {
        return request({
            url: '/apply/info/'+applyId,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: {}
        })
    },
    getChangeLineQuotationApplyInfo: (data) => {
        return request({
            url: '/apply/lineChangeInit',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    createApplyInfo: (data) => {
        return request({
            url: '/apply/createApply',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    createLineChangeApplyInfo: (data) => {
        return request({
            url: '/apply/createChangeApply',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    updateApplyInfo: (data) => {
        return request({
            url: '/apply/update',
            async: false,//同步方法
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    createApplyLine: (data) => {
        return request({
            url: '/apply/createApplyLine',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    delSelQuotationApplyLine: (quotationApplId,data) => {
        return request({
            url: '/apply/deleteApplyLine/'+quotationApplId,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    delSelQuotationApply: (data) => {
        return request({
            url: '/apply/deleteApply',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    submitApplyInfo: (data) => {
        return request({
            url: '/apply/submitApply',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    closeApplyInfo: (data) => {
        return request({
            url: '/apply/closeApply',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getQuotationApplyInfoShow: (applyId) => {
        return request({
            url: '/apply/infoShow/'+applyId,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: {}
        })
    },
    exportDetail:(applyId)=> {
      return request({
          url: `apply/exportDetail/${applyId}`,
          method: 'post',
          responseType: 'blob',
          fullResponse: true
      });
    },
    onExport:(data)=> {
      return request({
          url: `quotation/exportQuotatioProductnHistoryDetail`,
          data:data,
          method: 'post',
          responseType: 'blob',
          fullResponse: true
      });
    },
    
}